import { render, staticRenderFns } from "./order-modal-general-update.vue?vue&type=template&id=63ff43a5&scoped=true"
import script from "./order-modal-general-update.vue?vue&type=script&lang=js"
export * from "./order-modal-general-update.vue?vue&type=script&lang=js"
import style0 from "./order-modal-general-update.vue?vue&type=style&index=0&id=63ff43a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff43a5",
  null
  
)

export default component.exports